import { usePage } from '@inertiajs/vue3';
export function permissionCheck() {
    const permissions = usePage().props.auth.permissions;
    function can(permission) {
        if (usePage().props.auth.role == 'superadmin' ||
            usePage().props.auth.role == 'tenantadmin') {
            return true;
        }
        return permissions.includes(permission);
    }
    return {
        can,
    };
}
